
/**************************************************************************************************/
/*   File: /src/app/shared/models/geometry.ts                                              */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Wednesday May 29th 2019                                                        */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Thu May 30 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { Bbox } from './bbox';
/**
 * The geometry
 */
export class Geometry {
    /**
     * The crs code
     * @type {string}
     */
    crsCode: string;
    /**
    * The wkt
    * @type {string}
    */
    wkt: string;
    /**
     * The bbox of geometry wkt
     * @type {Bbox}
     */
    bbox?: Bbox;

}